<template>
    <div class="container">
        <hr />
        <div class="columns has-text-centered is-vcentered">
            <div class="column time-img">
                <h4>opening times</h4>
            </div>
            <div class="column details">
                <a name="times"></a>
                <font-awesome-icon icon="clock" class="fa is-hidden-mobile" />
                <br>
                <!--                <h3 class="statement">opening times</h3>-->
                <br />
                <div class="columns is-mobile">
                    <div class="column has-text-right">
                        <p class="day">Monday</p>
                        <br>
                        <p class="day">Tuesday</p>
                        <br>
                        <p class="day">Wednesday</p>
                        <br>
                        <p class="day">Thursday</p>
                        <br>
                        <p class="day">Friday</p>
                        <br>
                        <p class="day">Saturday</p>
                        <br>
                        <p class="day">Sunday</p>
                    </div>
                    <div class="column has-text-left">
                        <p class="day">Closed</p>
                        <br>
                        <p class="day">9:30am - 6:00pm</p>
                        <br>
                        <p class="day">9:30am - 5:00pm</p>
                        <br>
                        <p class="day">9:30am - 6:00pm</p>
                        <br>
                        <p class="day">9:30am - 6:00pm</p>
                        <br>
                        <p class="day">8:30am - 2:30pm</p>
                        <br>
                        <p class="day">Closed</p>
                    </div>

                </div>
<!--                <p>*wlk-in = walk in</p>-->
<!--                <p>*appts = appointments</p>-->

            </div>
        </div>
        <!--        <hr class="divider">-->
    </div>
</template>
<script>
    export default {
        name: 'opening'
    }

</script>
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Major+Mono+Display');


    h4 {
        font-family: 'Major Mono Display', monospace;
        font-weight: 800;
        font-size: 1.5rem;
        color: white;
        padding-top: 275px;

    }

    .divider {

        margin-bottom: 35px;

    }

    .container {

        margin-top: 25px;
        margin-bottom: 25px;

    }

    .statement {

        margin-top: 10px;

    }

    .fa {

        font-size: 5rem;

    }

    .time-img {

        background-image: url('../assets/logan-mountain.jpg');
        border-radius: 6px 6px 6px 6px;
        -moz-border-radius: 6px 6px 6px 6px;
        -webkit-border-radius: 6px 6px 6px 6px;
        background-size: cover;
        width: 100%;
        height: 650px;

    }

    .price-img {

        background-image: url('../assets/logan-boat.jpg');
        border-radius: 6px 6px 6px 6px;
        -moz-border-radius: 6px 6px 6px 6px;
        -webkit-border-radius: 6px 6px 6px 6px;
        background-size: cover;
        width: 100%;
        height: 450px;

    }

    .details {

        /*        height: auto;*/
        /*        background-color: #f7f7f7;*/

    }

</style>
